import { createSlice } from "@reduxjs/toolkit";

export const loanFilterSlice = createSlice({
  name: "filters",
  initialState: {
    filters: {},
    loanApplicationFilters: {},
    dealerBonusFilter: {},
  },
  reducers: {
    setFilters: (state, action) => {
      return {
        ...state,
        filters: {
          ...action.payload,
        },
      };
    },
    setLoanApplicationFilter: (state, action) => {
      return {
        ...state,
        loanApplicationFilters: action.payload,
      };
    },
    setDealerBonusFilter: (state, action) => {
      return {
        ...state,
        dealerBonusFilter: { ...state.dealerBonusFilter, ...action.payload },
      };
    },
    resetLoanFilters: (state) => {
      return {
        ...state,
        filters: {},
        loanApplicationFilters: {},
        dealerBonusFilter: {},
      };
    },
  },
});

export const {
  setFilters,
  setLoanApplicationFilter,
  resetLoanFilters,
  setDealerBonusFilter,
} = loanFilterSlice.actions;

export default loanFilterSlice.reducer;
